import { isAxiosError } from "axios";

/** Reads the API's `{ error }` body, or the first DRF field error. */
export const errorMessageFrom = (err: unknown, fallback: string): string => {
  if (!isAxiosError(err)) return fallback;
  const data = err.response?.data;
  if (typeof data?.error === "string") return data.error;
  if (data && typeof data === "object") {
    const first = Object.values(data)[0];
    if (Array.isArray(first) && typeof first[0] === "string") return first[0];
    if (typeof first === "string") return first;
  }
  return fallback;
};
